import {modals} from '@mantine/modals';
import {Text, Button} from '@mantine/core';
import {FaTrash} from 'react-icons/fa';
import {useParams} from 'react-router-dom';

import {useNotificationSubscriptions} from '../hooks/useNotificationSubscriptions.ts';
import {NotificationSubscription} from '../types';

interface DeleteRecordButtonProps {
    selectedRecords: NotificationSubscription[];
    setSelectedRecords: (records: NotificationSubscription[]) => void;
}

export const DeleteRecordButton = ({selectedRecords, setSelectedRecords}: DeleteRecordButtonProps) => {
    const {id: productId} = useParams();

    if (!productId) {
        throw new Error('productId is required parameter');
    }

    const {deleteRecords} = useNotificationSubscriptions(productId);

    const count = selectedRecords.length;
    const disabled = count === 0;

    const handleDelete = () => {
        const itemText = count === 1 ? 'item' : 'items';

        modals.openConfirmModal({
            title: 'Delete Notification Subscriptions',
            children: (
                <Text size="sm">
                    Are you sure you want to delete {count} {itemText}? This action cannot be undone.
                </Text>
            ),
            labels: {confirm: 'Delete', cancel: 'Cancel'},
            confirmProps: {color: 'red'},
            onConfirm: () => {
                const ids = selectedRecords.map(record => record.subscriptionArn).filter(Boolean) as string[];
                deleteRecords(ids);
                setSelectedRecords([]);
            },
        });
    };

    const buttonText = count > 0 ? `Delete (${count})` : 'Delete';

    return (
        <Button
            variant="outline"
            color="red"
            leftSection={<FaTrash size={16}/>}
            disabled={disabled}
            onClick={handleDelete}
        >
            {buttonText}
        </Button>
    );
};
